import { StatusTypes } from "../../variables";

const StatusBubble = ({ status }) => {
  let boxClasses = ["border-2 px-3 rounded-full font-semibold"];

  switch (status) {
    case StatusTypes.NOTSTARTED:
      boxClasses.push(
        "bg-orange-50 border-orange-300 text-orange-400 dark:bg-orange-600 dark:border-orange-500 dark:text-orange-50"
      );
      break;
    case StatusTypes.INPROGRESS:
      boxClasses.push(
        "bg-teal-50 border-teal-300 text-teal-400 dark:bg-teal-600 dark:border-teal-500 dark:text-teal-50"
      );
      break;
    case StatusTypes.COMPLETED:
      boxClasses.push(
        "bg-lime-50 border-lime-300 text-lime-400 dark:bg-lime-600 dark:border-lime-500 dark:text-lime-50"
      );
      break;
    default:
      break;
  }

  return <div className={boxClasses.join(" ")}>{status}</div>;
};

export default StatusBubble;
